define((require) => {
    "use strict";

    const ErrorLogger       = require("shared/services/error/ErrorLogger");
    const LoggedIn          = require("shared/security/LoggedIn");
    const LoggedInUserState = require("shared/ui/user/LoggedInUserState");
    const Sentry            = require("@sentry/browser");
    const EventDispatcher   = require("shared/util/EventDispatcher");

    return ErrorLogger.extend({

        constructor(config) {
            this.__super(config.errorQueueURL, ErrorLogger.Context.EDITOR);
            this.logErrorsToSentry = !!config.sentryEnabled && !!config.sentryDSN && !!config.version && !!config.trackErrors;

            // Add Sentry error handling.
            // NOTE: release tags are global to the account so we're prefixing with "creator@"
            if (this.logErrorsToSentry) {
                this._listener = new EventDispatcher();
                this._listener.listenTo(LoggedInUserState, "change:ready", () => this._addUserInfoToErrorLogger());
                let sentryConfig = {
                    dsn: config.sentryDSN,
                    environment: config.env
                };
                if (config.env === "PROD") {
                    sentryConfig.release = `creator@${config.version}`;
                }
                Sentry.init(sentryConfig);
            }
        },

        _addUserInfoToErrorLogger() {
            if (this.logErrorsToSentry && LoggedInUserState.get("ready")) {
                const company = LoggedInUserState.get("company");
                const user = LoggedInUserState.get("user");
                Sentry.configureScope((scope) => {
                    scope.setUser({
                        id: user.get("id"),
                        email: user.get("username"),
                        username: user.get("name")
                    });
                    scope.setTag("company.name", company.get("name"));
                    scope.setTag("company.id", company.get("id"));
                    // Storing user.role as a tag because arbitrary key/value pairs within "user" are unsearchable.
                    // Reference: https://docs.sentry.io/enriching-error-data/additional-data/
                    scope.setTag("user.role", user.get("role").name);
                });
            }
        },

        _additionalInfo() {
            const principal = LoggedIn.principal();

            if (principal) {
                const user = principal.get("user");

                return {
                    location:  LoggedInUserState.get("location"),
                    userName:  principal.get("displayName"), // may reflect ad login
                    tokenType: principal.get("type"),
                    userId:    user.get("id"),
                    email:     user.get("username")
                };
            }
            return {};
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/services/error/EditorErrorLogger.js